interface PageMetaInfo {
  title: string;
  description: string;
}

export const getPageMetaInfo = (path: string): PageMetaInfo => {
  const cleanPath = path === '/' ? path : path.replace(/\/$/, '');
  
  const metaMap: Record<string, PageMetaInfo> = {
    '/': {
      title: "OMN SEO Tools - Professionelle SEO-Tools für Ihren Online-Erfolg",
      description: "Entdecken Sie OMN SEO Tools, Ihre Plattform für effektive SEO-Strategien und nachhaltige Steigerung von Sichtbarkeit und Traffic."
    },
    '/keyword-analyse': {
      title: "Keyword-Analyse Tool für SEO | OMN SEO Tools",
      description: "Finden Sie heraus, welche Keywords Ihre Zielgruppe sucht. Unser SEO-Tool hilft Ihnen bei der strategischen Keyword-Recherche."
    },
    '/backlink-profil': {
      title: "Backlink Profil Analyse Tool | OMN SEO Tools",
      description: "Analysieren und optimieren Sie Ihr Backlink-Profil mit unserem professionellen SEO-Tool. Erkennen Sie toxische Links und verbessern Sie Ihre Linkqualität."
    },
    '/content-optimierung': {
      title: "Content-Optimierung Tool für SEO | OMN SEO Tools",
      description: "Optimieren Sie Ihren Content für bessere Rankings. Unser Tool analysiert Ihre Texte und gibt konkrete Verbesserungsvorschläge für SEO."
    },
    '/serp-snippet': {
      title: "SERP Snippet Generator & Optimierung | OMN SEO Tools",
      description: "Erstellen Sie optimale Meta-Titel und Beschreibungen für bessere Klickraten in den Suchergebnissen. Testen Sie verschiedene Varianten."
    },
    '/link-optimierer': {
      title: "Link-Optimierung Tool | OMN SEO Tools",
      description: "Verbessern Sie Ihre interne Verlinkung und Linkstruktur. Unser Tool hilft Ihnen, Ihre Website-Architektur zu optimieren."
    },
    '/lokale-seo': {
      title: "Lokale SEO Optimierung | OMN SEO Tools",
      description: "Steigern Sie Ihre lokale Sichtbarkeit mit unserem Local SEO Tool. Optimieren Sie Ihr Business für lokale Suchanfragen."
    },
    '/performance-check': {
      title: "Website Performance Check | OMN SEO Tools",
      description: "Analysieren Sie die Performance Ihrer Website. Identifizieren Sie Geschwindigkeitsprobleme und optimieren Sie die Ladezeit."
    },
    '/mobile-seo': {
      title: "Mobile SEO Optimierung | OMN SEO Tools",
      description: "Optimieren Sie Ihre Website für mobile Endgeräte. Verbessern Sie das mobile Nutzererlebnis und steigern Sie Ihre Rankings."
    },
    '/knowledge': {
      title: "SEO Wissensdatenbank | OMN SEO Tools",
      description: "Nutzen Sie unsere Wissensdatenbank mit hilfreichen Tipps und Anleitungen, um Ihre SEO-Strategien zu verbessern."
    },
    '/about': {
      title: "Über uns - OMN SEO Tools | Schweizer SEO-Expertise",
      description: "Erfahren Sie mehr über OMN SEO Tools, unser Team und unsere Mission, Ihnen zu besseren Rankings und mehr Erfolg zu verhelfen."
    },
    '/contact': {
      title: "Kontakt - OMN SEO Tools | Ihre SEO-Experten in der Schweiz",
      description: "Kontaktieren Sie die SEO-Experten von OMN SEO Tools. Wir beraten Sie gerne zu allen Fragen rund um Suchmaschinenoptimierung."
    },
    '/privacy': {
      title: "Datenschutzerklärung | OMN SEO Tools",
      description: "Erfahren Sie, wie wir Ihre Daten schützen und welche Massnahmen wir ergreifen, um Ihre Privatsphäre zu gewährleisten."
    },
    '/terms': {
      title: "Nutzungsbedingungen | OMN SEO Tools",
      description: "Lesen Sie unsere Nutzungsbedingungen. Hier finden Sie alle wichtigen Informationen zur Nutzung unserer SEO-Tools und Services."
    }
  };
  
  return metaMap[cleanPath] || metaMap['/'];
};